const vt = {
  cu: () =>
    "serviceWorker" in navigator &&
    "undefined" != typeof ServiceWorkerRegistration &&
    "showNotification" in ServiceWorkerRegistration.prototype &&
    "PushManager" in window,
  lu: () =>
    "safari" in window &&
    "pushNotification" in window.safari &&
    "function" == typeof window.safari.pushNotification.permission &&
    "function" == typeof window.safari.pushNotification.requestPermission,
  isPushSupported: () => vt.cu() || vt.lu(),
  isPushBlocked: () => {
    const o =
        vt.isPushSupported() &&
        "Notification" in window &&
        null != window.Notification &&
        null != window.Notification.permission &&
        "denied" === window.Notification.permission,
      i =
        vt.isPushSupported() &&
        (!("Notification" in window) || null == window.Notification);
    return o || i;
  },
  isPushPermissionGranted: () =>
    vt.isPushSupported() &&
    "Notification" in window &&
    null != window.Notification &&
    null != window.Notification.permission &&
    "granted" === window.Notification.permission,
  En: () =>
    vt.isPushBlocked()
      ? { Gn: !1, reason: "blocked" }
      : vt.isPushSupported()
      ? vt.isPushPermissionGranted()
        ? { Gn: !1, reason: "permissionGranted" }
        : { Gn: !0 }
      : { Gn: !1, reason: "unsupported" },
  Nn: (o, i) =>
    "blocked" === o
      ? `${i} containing a push prompt is not being shown because the user has already declined push permission prompt.`
      : "unsupported" === o
      ? `${i} containing a push prompt is not being shown because the browser doesn't support push notifications.`
      : `${i} containing a push prompt is not being shown because the user has already accepted the permission prompt.`,
};
export default vt;
